/* istanbul ignore file */
import React from 'react';
import { ListBreadcrumbItem, Breadcrumbs, BreadcrumbsProps } from 'framework/ui/BreadCrumbs';
import { useAssignmentUrl } from 'domain/shared/assignment';

const AssignmentBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getListUrl } = useAssignmentUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Assignment" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default AssignmentBreadcrumbs;
